import React from 'react'
import MoveSparksModal from "../../components/Spectra/Models/MoveSparksModal";
import SpectraDeletedModal from "../../components/Alerts/SpectraDeletedModel";
import SpectraDeleteModal from "../../components/Spectra/Models/SpectraDeleteModal";
import SpectraDetailsModal from "../../components/Spectra/Models/SpectraDetailsModal";

const ModalsLayout = () => {
    return (
        <>
            <SpectraDeleteModal />
            <MoveSparksModal />
            <SpectraDeletedModal />
            <SpectraDetailsModal />
        </>
    )
}

export default ModalsLayout
